import { defineFcm } from '../shared/factory';

export const FCM_SIGN_INTENT_VALID_SAMPLE_RATE = defineFcm('sign_intent_valid_sample_rate')
	.asNumber()
	.withDefault(15)
	.toConfig({
		owner: 'TBD',
		scope: 'corgi-front-end',
		context: 'petition page',
		description: `Sampling rate for which the sign_intent_valid event should be tracked.
			For instance, if value is 30, 30% of the sign_intent_valid events will be tracked.
			Default value is 15.`,
		import: false,
	});
